module.exports = __webpack_public_path__ + "static/media/cafe24-body2-2-2.6ba31aa0.png";